import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { PlanCuidadoCreationContent } from './components/PlanCuidadoCreationContent';

export default function PlanCuidadoCreation() {
    return (
        <MainContent
            component={<PlanCuidadoCreationContent />}
            titulo='Plan Cuidado'
            noBackground
        />
    );

};
